{
    "Profile_Notes.notes": "Notes",
    "Profile_Notes.action": "Action",
    "Profile_Notes.refresh": "Refresh",
    "Profile_Notes.addNew": "Add new",
    "Profile_Notes.by": "by: {name} / {date}",
    "Profile_Notes.addNewNote": "Add new Note",
    "Profile_Notes.enterYourNoteHere": "Enter your note here",
    "Profile_Notes.cancel": "Cancel",
    "Profile_Notes.add": "Add",
    "Profile_Notes.editNote": "Edit Note",
    "Profile_Notes.update": "Update"
}
